// extracted by mini-css-extract-plugin
module.exports = {"main":"Galerija_main__3Xnox","headline":"Galerija_headline__1vz2f","firstDiv":"Galerija_firstDiv__2_DO_","secondDiv":"Galerija_secondDiv__xBqO0"};